export const difference = <T>(firstArray: T[], secondArray: T[]): T[] => {
    return firstArray.filter((item) => !secondArray.includes(item));
};
